module.exports = __webpack_public_path__ + "bf2532df/img/cadBim.e369a02a.png";